var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52827 5.52925C7.78862 5.2689 8.21073 5.2689 8.47108 5.52925L12.4711 9.52925C12.7314 9.7896 12.7314 10.2117 12.4711 10.4721C12.2107 10.7324 11.7886 10.7324 11.5283 10.4721L7.99967 6.94346L4.47108 10.4721C4.21073 10.7324 3.78862 10.7324 3.52827 10.4721C3.26792 10.2117 3.26792 9.7896 3.52827 9.52925L7.52827 5.52925Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.9a85638b65fea43ef607e0994bba5d7d.svg";
export { ForwardRef as ReactComponent };